import { render, staticRenderFns } from "./leftSidebar.vue?vue&type=template&id=b5b50e18&scoped=true"
import script from "./leftSidebar.vue?vue&type=script&lang=js"
export * from "./leftSidebar.vue?vue&type=script&lang=js"
import style0 from "./leftSidebar.vue?vue&type=style&index=0&id=b5b50e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b50e18",
  null
  
)

export default component.exports